// app-modal.component.ts
import { Component, Input, Output, EventEmitter, OnInit, Inject, AfterViewInit } from '@angular/core';
import { MysynchModalComponent } from '../mysynch-modal/mysynch-modal.component';
import {moment} from '../../../js/globals.js';
import _ from 'lodash';
import { ModalDataService } from '../../services/modal-data.service';
import { MySynchConstantService } from '../../services/mysynch.constant.service';
import { PerformanceMetricsService } from '../../services/performance-metrics.service';
import { PerformanceContextService } from '../../services/performance-context.service';
import { PerformanceContext } from '../../interfaces/mysynch.interfaces';

@Component({
  standalone: false,
  selector: 'outofdate-data-modal',
  templateUrl:"../app/modals/outofdate-data-modal/outofdate-data-modal.view.html",
  styleUrls: ["../app/modals/outofdate-data-modal/outofdate-data-modal.style.css"],
})
export class OutofdateDataModalComponent extends MysynchModalComponent implements OnInit, AfterViewInit {
  
  private hideNotification: boolean = false;   
  private outofdateDataLocalStorageTmpl: any = {personId: null ,herdId:null,expiry:null, dirty: false};
  private currentActiveHerd: any = null;
  private extendedHideNotificaitonNumDays: number = 0;
  private performanceContext: PerformanceContext | null = null;
  dateFormat:any			= null;
  @Input() configuration: any = {};
  @Input() customData: any;
  @Output() closeModal = new EventEmitter<{ error: any; data: any }>(); // Emit an object with error and data properties
  

  constructor(@Inject('MySynchFactory') protected MSF: any,
              @Inject('ApiFactory') protected api: any,
              @Inject(ModalDataService) protected modalDataService: ModalDataService,
              @Inject(MySynchConstantService) protected mySynchConstantService: MySynchConstantService,
              @Inject(PerformanceMetricsService) protected perfMetricSvc: PerformanceMetricsService,
              @Inject(PerformanceContextService) protected perfContextSvc: PerformanceContextService) {
    super(MSF,api,modalDataService,mySynchConstantService,perfMetricSvc); 
  }

    private initializeModal(){
      this.title = _.get(this.configuration,'title',"Farm Data Out of Date");

      this.extendedHideNotificaitonNumDays = this.modalDataService.getOutOfDateDataNumDaysExtendedHideLimit();
          
      // getting latest cow event date 
      var latestCowEventDate = ''; 
      var currentActiveHerdAdditionalHerdData = this.MSF.getAdditionalHerdDataItem(_.get(this.currentActiveHerd,'herdId'));
      var latestCowEventDateString = _.get(currentActiveHerdAdditionalHerdData, 'dataCurrency.metaLastEventDate');
      if(!_.isUndefined(latestCowEventDateString) && !_.isNull(latestCowEventDateString)){
        latestCowEventDate = moment(latestCowEventDateString).format(this.dateFormat);
      }
      // getting territory manager info
      var territoryManager = this.MSF.getActiveFarmTerritoryManager();

      // getting the number of days old threshold
      var daysOldThreshold = this.modalDataService.getOutOfDateDataNumDaysOldLimit();
      
      
      var message = `<b>Warning:</b> Your mySYNCH information is more than ${daysOldThreshold} days old.<br /><br /> Please contact your local Parnell Territory Manager ${_.get(territoryManager,'name')} at <a href='mailto:${_.get(territoryManager,'email')}' class='btn-link link-color text-blue-important'>${_.get(territoryManager,'email')}</a> or <a href='tel://${_.get(territoryManager,'phone')}' class='btn-link link-color text-blue-important'>${_.get(territoryManager,'phone')}</a> for help making your information current.<br /><br /> Click Continue to view your reports last updated on ${latestCowEventDate}.`  
      this.message = _.get(this.configuration,'message',message);
      
      this.withBlur = _.get(this.configuration,'withBlur',this.withBlur);
      this.showModal = true; // _.get(this.configuration,'showModal',this.showModal);
    }

    ngOnInit() {
             
      this.MSF.getActiveHerdWithWait().then((activeHerd) => {
          this.performanceContext = this.perfContextSvc.createPerformanceContext(_.get(activeHerd,'herdId',null));
           this.perfMetricSvc.startTiming("Component:OutofdateDataModal:Render");
           this.currentActiveHerd = activeHerd;
           this.dateFormat = this.MSF.getActiveHerdTimeFormatWithLongDigitYear();
           this.initializeModal();
        }, (error) => {
          console.log("error getting active herd in OutofdateDataModalComponent ngOnInit()");
          this.dateFormat = this.MSF.getActiveHerdTimeFormatWithLongDigitYear();
          // even if there is an error getting the active herd, we still want to initialize the modal
          this.initializeModal();
        });
    
    }
  ngAfterViewInit() {
       this.MSF.getActiveHerdWithWait().then((activeHerd) => {
          this.perfMetricSvc.endTiming("component","Component:OutofdateDataModal:Render",this.performanceContext);
      });
  }

  onConfirm() {
   
    var currentHerdId = _.get(this.MSF.getActiveHerd(),'herdId');
    var currentPersonId = _.get(this.MSF,'cookies.user.PersonId');
    var existingOutofdateDataExpiries = this.MSF.getParsedLocalStorageItem(this.mySynchConstantService.outofdateDataExpiries);

    var outofdateDataExpiries = [];

    if(!_.isUndefined(existingOutofdateDataExpiries)){
        outofdateDataExpiries = _.reject(existingOutofdateDataExpiries, function(expiryItem) { return _.isEqual(_.get(expiryItem,'herdId'),currentHerdId) && _.isEqual(_.get(expiryItem,'personId'),currentPersonId); });
    }
    // set the initial expiry to the current date at the end of the day
    var newOutofdateDataExpiry = moment().add(1,'day').startOf('day');
    

    if(this.hideNotification){
         newOutofdateDataExpiry = moment().add(this.extendedHideNotificaitonNumDays,'days').startOf('day');
    }

   
   var newOutofdateDataExpiryItem = _.cloneDeep(this.outofdateDataLocalStorageTmpl);
   _.set(newOutofdateDataExpiryItem,'personId',currentPersonId);
   _.set(newOutofdateDataExpiryItem,'herdId',currentHerdId);
   
   var  newOutofdateDataExpiryBrowserStoredString = newOutofdateDataExpiry.format("YYYY-MM-DDTHH:mm:ss");
   var  newOutofdateDataExpiryDBStoredString  = newOutofdateDataExpiryBrowserStoredString + 'Z';
   _.set(newOutofdateDataExpiryItem,'expiry',newOutofdateDataExpiryBrowserStoredString);

   outofdateDataExpiries.push(newOutofdateDataExpiryItem);
   outofdateDataExpiries = _.sortByOrder(outofdateDataExpiries, ["personId","herdId","expiry"], ["asc","asc","asc"]);
   localStorage.setItem('outofdateDataExpiries',JSON.stringify(outofdateDataExpiries));
  
   var appLevelNotificationId = _.get(_.find(_.get(this.MSF,'lists.appLevelNotifications',[]),{name:this.mySynchConstantService.outofdateDataNotificationName}),'notificationId');

    this.api.upsertPersonAppLevelNotification(currentPersonId,currentHerdId,appLevelNotificationId,newOutofdateDataExpiryDBStoredString,(error,data)=>{
        if(error){
            console.log("error upserting person app level notification in OutofdateDataModalComponent onConfirm()");
        }
    });
  
   this.closeModal.emit(_.cloneDeep(this.closeModalDataTmpl)); 
  }
  onCancel() {
    this.closeModal.emit(_.cloneDeep(this.closeModalDataTmpl)); // Just emit the event without any data
  }
}
